<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    :style="{ '--icon-size': typeof size === 'number' ? `${size}px` : size }"
    :class="['lucide', 'lucide-network', { 'is-inherit': variant === 'inherit' }]"
    aria-hidden="true"
  >
    <rect x="16" y="16" width="6" height="6" rx="1" />
    <rect x="2" y="16" width="6" height="6" rx="1" />
    <rect x="9" y="2" width="6" height="6" rx="1" />
    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3" />
    <path d="M12 12V8" />
  </svg>
</template>

<script setup>
defineProps({
  size: { type: [Number, String], default: 24 },
  variant: {
    type: String,
    default: 'amber',
    validator: value => ['amber', 'inherit'].includes(value),
  },
})
</script>

<style scoped>
.lucide-network {
  display: inline-block;
  vertical-align: middle;
  width: var(--icon-size, 1.5rem);
  height: var(--icon-size, 1.5rem);
  color: #fbbf24; /* text-amber-400 */
}

.lucide-network.is-inherit {
  color: currentColor;
}
</style>
